<template>
  <Polyline :options="{
      path: latLngPath,
      geodesic: false,
      strokeColor: '#73B9FF',
      strokeOpacity: 0.7,
      strokeWeight: 5,
    }"/>
</template>

<script setup>
import {Polyline} from 'vue3-google-map';

import {ref, watch} from "vue";

const props = defineProps({
  googlePath: {
    type: Array
  }
})

// Holds the route points
const latLngPath = ref([]);

watch(() => props.googlePath, (googlePath) => {
  if (googlePath) {
    latLngPath.value = googlePathToLatLngPath(googlePath);
  }
});

// convert a list from google's path format to simple {lat: x, lng: y} objects
function googlePathToLatLngPath(googlePath) {
  return googlePath.map(point => ({
    lat: point.lat(),
    lng: point.lng(),
  }));
}
</script>

<style scoped>

</style>
